import { render } from "./medicineRespPul.vue?vue&type=template&id=bfd0e0ce&scoped=true"
import script from "./medicineRespPul.vue?vue&type=script&lang=js"
export * from "./medicineRespPul.vue?vue&type=script&lang=js"

import "./medicineRespPul.vue?vue&type=style&index=0&id=bfd0e0ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd0e0ce"]])

export default __exports__